// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"U2","heading":"V2","item":"W2","fadeIn":"X2","imagewrapper":"Y2","modalheader":"Z2","amount":"a3","name":"b3","desc":"c3","moredetails":"e3","ingheader":"f3"};
    if(module.hot) {
      // 1714654899881
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  